<script lang="ts" setup>
import { usePaneStore } from '#layers/ui/public';

const paneStore = usePaneStore();
</script>

<template>
	<DTooltip
		:text="paneStore.sidebarOpen ? $t('sidebar.collapse') : $t('sidebar.expand')"
	>
		<DButton
			size="sm"
			variant="ghost"
			color="neutral"
			:icon="paneStore.sidebarOpen ? 'lucide:sidebar-close' : 'lucide:sidebar'"
			class="rounded-sm"
			:aria-label="paneStore.sidebarOpen ? $t('sidebar.collapse') : $t('sidebar.expand')"
			@click="paneStore.toggleSidebar()"
		/>
	</DTooltip>
</template>
